/* eslint-disable camelcase */
import { gql } from '@/core/shared/api';

export const getLocationWebhooks = async ({ commit, dispatch }, locationId) => {
  commit('setLoading', true);
  commit('webhooks/set', { path: 'isFetchingWebhooks', value: true });

  const query = `query GetByLocation {
    locationWebhooksByLocation(location_id: "${locationId}") {
      data {
        id
        event_type
        url
        is_active
        location_id
        source
      }
    }
  }`;

  try {
    const data = await gql.request(query);

    dispatch('insertEntities', {
      name: 'Webhook',
      payload: data.locationWebhooksByLocation.data,
    });

    return data.locationWebhooksByLocation.data;
  } finally {
    commit('setLoading', false);
    commit('webhooks/set', { path: 'isFetchingWebhooks', value: false });
  }
};

export const getLocationWebhook = async ({ commit, dispatch }, { webhookId }) => {
  commit('setLoading', true);
  commit('webhooks/set', { path: 'isFetchingWebhooks', value: true });

  const query = `query GetSingleWebhook {
    locationWebhook(id: "${webhookId}") {
      id
      event_type
      url
      is_active
      location_id
      source
    }
  }`;

  try {
    const data = await gql.request(query);
    dispatch('insertEntities', {
      name: 'Webhook',
      payload: data.locationWebhook,
    });

    return data.locationWebhook;
  } finally {
    commit('setLoading', false);
    commit('webhooks/set', { path: 'isFetchingWebhooks', value: false });
  }
};

export const storeWebhook = async ({ dispatch, commit }, webhook) => {
  commit('setLoading', true);

  const query = `
    mutation StoreLocationWebhook($webhookInput: LocationWebhookInput!) {
      storeLocationWebhook(webhook: $webhookInput) {
        id
        location_id
        event_type
        url
        is_active
        source
        created_at
        updated_at
      }
    }
  `;

  const {
    id,
    location_id,
    event_type,
    url,
    is_active,
    source,
  } = webhook;

  const webhookInput = {
    id,
    location_id,
    event_type,
    url,
    is_active,
    source,
  };

  try {
    const data = await gql.request(query, { webhookInput });
    const storedWebhook = data.storeLocationWebhook;

    dispatch('insertEntities', {
      name: 'LocationWebhook',
      payload: storedWebhook,
    });

    return storedWebhook;
  } finally {
    commit('setLoading', false);
  }
};

export const deleteWebhook = async ({ dispatch }, webhook) => {
  const { id } = webhook;

  const query = `
    mutation DeleteWebhook($id: ID!) {
      deleteLocationWebhook(webhook: { id: $id }) {
        id
        event_type
        url
      }
    }
  `;

  dispatch('removeEntities', {
    name: 'Webhook',
    payload: { id },
  });

  const variables = { id };
  const data = await gql.request(query, variables);
  return data.deleteLocationWebhook;
};
